__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "pme-mfe-shared";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@ariakit/react", "0.4.26", () => (Promise.all([__webpack_require__.e(5798), __webpack_require__.e(6394), __webpack_require__.e(7656), __webpack_require__.e(5686)]).then(() => (() => (__webpack_require__(6394))))));
			register("@nike/podium", "1.4.0", () => (Promise.all([__webpack_require__.e(4040), __webpack_require__.e(5798), __webpack_require__.e(3477), __webpack_require__.e(976), __webpack_require__.e(371), __webpack_require__.e(7656), __webpack_require__.e(5686), __webpack_require__.e(2708), __webpack_require__.e(4649)]).then(() => (() => (__webpack_require__(371))))));
			register("@radix-ui/react-dropdown-menu", "2.1.24", () => (Promise.all([__webpack_require__.e(5798), __webpack_require__.e(3477), __webpack_require__.e(976), __webpack_require__.e(8934), __webpack_require__.e(7656), __webpack_require__.e(5686)]).then(() => (() => (__webpack_require__(8934))))));
			register("@radix-ui/react-tooltip", "1.2.16", () => (Promise.all([__webpack_require__.e(5798), __webpack_require__.e(3477), __webpack_require__.e(9802), __webpack_require__.e(7656), __webpack_require__.e(5686)]).then(() => (() => (__webpack_require__(9802))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(7569), __webpack_require__.e(4319), __webpack_require__.e(4741)]).then(() => (() => (__webpack_require__(4741))))));
			register("clsx", "1.2.1", () => (__webpack_require__.e(53).then(() => (() => (__webpack_require__(53))))));
			register("cookies-js", "1.2.3", () => (__webpack_require__.e(8338).then(() => (() => (__webpack_require__(8338))))));
			register("match-sorter", "8.3.0", () => (__webpack_require__.e(1545).then(() => (() => (__webpack_require__(1545))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(7656)]).then(() => (() => (__webpack_require__(961))))));
			register("react-error-boundary", "6.0.1", () => (Promise.all([__webpack_require__.e(7656), __webpack_require__.e(7696)]).then(() => (() => (__webpack_require__(7696))))));
			register("react-is", "18.3.1", () => (__webpack_require__.e(4363).then(() => (() => (__webpack_require__(4363))))));
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(8570), __webpack_require__.e(7656), __webpack_require__.e(5686), __webpack_require__.e(8494)]).then(() => (() => (__webpack_require__(8570))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(6540))))));
			register("redux-persist-cookie-storage", "1.0.0", () => (__webpack_require__.e(8545).then(() => (() => (__webpack_require__(8545))))));
			register("redux-persist-transform-compress", "4.2.0", () => (Promise.all([__webpack_require__.e(605), __webpack_require__.e(2832)]).then(() => (() => (__webpack_require__(2832))))));
			register("redux-persist-transform-filter", "0.0.22", () => (Promise.all([__webpack_require__.e(4811), __webpack_require__.e(605)]).then(() => (() => (__webpack_require__(4811))))));
			register("redux-persist", "6.0.0", () => (Promise.all([__webpack_require__.e(4319), __webpack_require__.e(4458)]).then(() => (() => (__webpack_require__(4458))))));
			initExternal(6004);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};